import { lazy } from 'react';

export const PatternStudioOverviewPageLazy = lazy(
    () => import('./pattern-studio-overview-page'),
);
